/**
 * Accordion shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

import tabs from '../../util/tabs'

tabs('accordion', {
	selectors: {
		wrap: '.accordion',
		toggles: '.accordion-item__button',
		content: '.accordion-item__content',
	},
})
